import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import {useEffect, useRef} from 'react';
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            margin-top: -3rem;
            text-align: center;

            &.adjust-addtolist {
                margin-top: 0;
                text-align: center;
            }

            @media (max-width: 1300px) {
                padding-right: 0;
                margin-top: -1rem;
                width: 100%;
                text-align: left;

                &.adjust-addtolist {
                    text-align: left;
                }
            }
            @media (max-width: 1200px) {
                text-align: left;
                width: 100%;
                margin-top: -.7rem;
                margin-bottom: .7rem;
                white-space: nowrap;
            }
            @media (max-width: 991px) {
                text-align: left;
                width: 100%;
                margin-top: -.7rem;
                margin-bottom: .7rem;
                white-space: nowrap;
            }
            @media (max-width: 767px) {
                &.adjust-addtolist {
                    text-align: left;
                }
            }            
            button {
                span {
                    color: #002554 !important;
                    font-size: .87rem;
                    text-decoration: underline;
                }
                :hover {
                    text-decoration: underline;
                    color: #002554 !important;
                }
            }
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (ref.current) {
                const pdpRightColumn = ref.current.closest('.pdp-right-column');
                const qtyContainer = pdpRightColumn?.querySelector('.qty-container-new');
                const qtyWrapper = qtyContainer?.parentElement;
                qtyWrapper?.parentElement?.classList.add('qty-wrapper');

                if (pdpRightColumn?.querySelector('.qty-container') === null) {
                    qtyWrapper?.parentElement?.classList.add('hide-element');
                    ref.current.classList.add('adjust-addtolist');
                }

                const pdpLeftColumn = ref.current.closest('.pdp-left-column');
                const qtyContainerLeft = pdpLeftColumn?.querySelector('.qty-container-new');
                const qtyWrapperLeft = qtyContainerLeft?.parentElement;
                qtyWrapperLeft?.parentElement?.classList.add('qty-wrapper');

                if (pdpLeftColumn?.querySelector('.qty-container') === null) {
                    qtyWrapperLeft?.parentElement?.classList.add('hide-element');
                    ref.current.classList.add('adjust-addtolist');
                }
            }
        }, 200);
    }, []);
    
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} ref={ref} className="addtolist-wrapper">
            <ProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.link} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
